import axios from 'axios';
import { handleApiError } from '../../utils/errorHandler';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://app.insight360apps.com/easycheck/api';

// Separate Axios instance for mobile — uses mobileToken
const mobileApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

mobileApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('mobileToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add company context headers from stored user
    const userStr = localStorage.getItem('mobileUser');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user.CompanyId || user.companyId) {
          config.headers['X-Company-Id'] = user.CompanyId || user.companyId;
        }
        if (user.UserId || user.userId) {
          config.headers['X-User-Id'] = user.UserId || user.userId;
        }
      } catch (e) {
        // ignore parse errors
      }
    }

    config.metadata = { startTime: new Date() };
    return config;
  },
  (error) => Promise.reject(error)
);

mobileApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('mobileToken');
      localStorage.removeItem('mobileUser');
      if (window.location.pathname.startsWith('/mobile') && !window.location.pathname.includes('/login')) {
        window.location.href = '/mobile/login';
      }
    }
    return Promise.reject(error);
  }
);

// Response wrapper matching easyCheckRequest pattern
const mobileRequest = async (requestFn) => {
  try {
    const response = await requestFn();
    const responseData = response.data;
    const success = responseData.success ?? responseData.Success ?? true;
    const data = responseData.data ?? responseData.Data ?? responseData;
    const message = responseData.message ?? responseData.Message ?? 'Success';

    return {
      success,
      data,
      message,
      TotalCount: responseData.TotalCount,
      PageNumber: responseData.PageNumber,
      PageSize: responseData.PageSize,
      TotalPages: responseData.TotalPages,
      totalCount: responseData.TotalCount || responseData.totalCount,
      pageNumber: responseData.PageNumber || responseData.pageNumber,
      pageSize: responseData.PageSize || responseData.pageSize,
      totalPages: responseData.TotalPages || responseData.totalPages
    };
  } catch (error) {
    return handleApiError(error);
  }
};

export { mobileApi, mobileRequest };
export default mobileApi;
